module.exports = __webpack_public_path__ + "static/media/vitalJoin1.919061af.svg";